import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { InfoDialog } from '@shared/dialogs';
import { ConfirmationDialog } from '@shared/dialogs/confirmation-dialog.component';
import { UserService } from '@shared/services';

type DialogSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full';
type DialogTextSize = 'small' | 'medium' | 'large' | 'multi';

@Component({
  selector: 'cipo-dialogs',
  imports: [FlexLayoutModule, MatButtonModule],
  templateUrl: './dialogs.component.html',
})
export class DialogsComponent {
  dialog = inject(MatDialog);
  userService = inject(UserService);

  texts: Partial<Record<DialogTextSize, string>> = {
    small: 'Small dialog, used for small content.',
    medium:
      'Large dialog, used for large content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula ac quam viverra nec consectetur ante hendrerit. Donec et mollis dolor. Praesent et diam eget libero egestas mattis sit amet vitae augue. ',
    large: `
        Extra large dialog, used for very large content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula ac quam viverra nec consectetur ante hendrerit. Donec et mollis dolor. Praesent et diam eget libero egestas mattis sit amet vitae augue.
        Extra large dialog, used for very large content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula ac quam viverra nec consectetur ante hendrerit. Donec et mollis dolor. Praesent et diam eget libero egestas mattis sit amet vitae augue.
        Extra large dialog, used for very large content. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec a diam lectus. Sed sit amet ipsum mauris. Maecenas congue ligula ac quam viverra nec consectetur ante hendrerit. Donec et mollis dolor. Praesent et diam eget libero egestas mattis sit amet vitae augue.
        `,
  };
  dialogsSizes: DialogSize[] = ['xs', 'sm', 'md', 'lg', 'xl', 'full'];
  textsSizes: DialogTextSize[] = ['small', 'medium', 'large', 'multi'];

  openInfoDialog(size: DialogSize, textSize: DialogTextSize) {
    this.dialog.open(InfoDialog, {
      panelClass: ['cipo', 'cipo-dialog', 'classic', ...(['full', 'xl'].includes(size) ? ['cipo--height--full'] : [])],
      ...this.userService.getResponsiveDialogSize()[size],
      data: {
        title: `${size} dialog with ${textSize} text`,
        enableFullscreen: true,
        ...(textSize === 'multi'
          ? { messages: Array.from({ length: 3 }, () => this.texts.large) }
          : { description: this.texts[textSize] }),
      },
    });
  }

  openConfirmationDialog(size: DialogSize, textSize: DialogTextSize) {
    this.dialog.open(ConfirmationDialog, {
      panelClass: ['cipo', 'cipo-dialog', 'classic', ...(['full', 'xl'].includes(size) ? ['cipo--height--full'] : [])],
      ...this.userService.getResponsiveDialogSize()[size],
      data: {
        title: `${size} dialog with ${textSize} text`,
        ...(textSize === 'multi'
          ? { messages: Array.from({ length: 3 }, () => this.texts.large) }
          : { description: this.texts[textSize] }),
      },
    });
  }
}
